import React, { useContext, useEffect, useState } from "react";
import "./Raml.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link, Navigate } from "react-router-dom";
import RamlC from "../../components/ramlc/RamlC";
import { MainContext } from "../../contexts/MainContext";
import HeaderB from "../../components/headerb/HeaderB";

export default function Raml() {
  let {
    setZayechB,
    setZayechC,
    setQuestionIdCon,
    setLotNameCon,
    setTitleIdCon,
  } = useContext(MainContext);

  const [state, setState] = useState(1);
  const [flag, setFlag] = useState(false);
  const [flag2, setFlag2] = useState(false);
  const [flag3, setFlag3] = useState(false);
  const [flag4, setFlag4] = useState(false);
  const [ZNameState, setZNameState] = useState(false);
  const mainContext = useContext(MainContext);

  useEffect(() => {
    mainContext.setSecondSelectDisabled(true);
    localStorage.removeItem("mainObj2");
    localStorage.removeItem("mainObject");

    setZayechB([]);
    setZayechC([]);
    setQuestionIdCon("");
    setLotNameCon("");
    setTitleIdCon("");
  }, []);

  const nextComponent = () => {
    if (flag && flag2 && flag3 && flag4) {
      setState((prev) => prev + 1);
      setFlag(false);
      setFlag2(false);
      setFlag3(false);
      setFlag4(false);
    }
  };

  const changFlag = (fl) => {
    setFlag(true);
  };
  const changFlag2 = (fl) => {
    setFlag2(true);
  };
  const changFlag3 = (fl) => {
    setFlag3(true);
  };
  const changFlag4 = (fl) => {
    setFlag4(true);
  };

  return (
    <>
      <Container fluid>
        <HeaderB />
      </Container>

      <Container className="raml-container">
        <Row>
          <Col>
            {state == 1 && (
              <RamlC
                classs={"raml-diva mt-3"}
                stat={state}
                chF={changFlag}
                chG={changFlag2}
                chH={changFlag3}
                chJ={changFlag4}
                flagg={flag}
                setZNameState={setZNameState}
              />
            )}
            {state == 2 && (
              <RamlC
                classs={"raml-diva b mt-3"}
                stat={state}
                chF={changFlag}
                chG={changFlag2}
                chH={changFlag3}
                chJ={changFlag4}
              />
            )}
            {state == 3 && (
              <RamlC
                classs={"raml-diva c mt-3"}
                stat={state}
                chF={changFlag}
                chG={changFlag2}
                chH={changFlag3}
                chJ={changFlag4}
              />
            )}
            {state == 4 && (
              <RamlC
                classs={"raml-diva d mt-3"}
                stat={state}
                chF={changFlag}
                chG={changFlag2}
                chH={changFlag3}
                chJ={changFlag4}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            <br />
            <br />
            {state < 4 && ZNameState && (
              <Button
                style={{ backgroundColor: "#9933cc" }}
                className={
                  flag && flag2 && flag3 && flag4 ? "btnRaml" : "btnRaml e"
                }
                to={""}
                onClick={nextComponent}
              >
                بعدی
              </Button>
            )}
            {state == 4 && (
              <Button
                style={{ backgroundColor: "#9933cc" }}
                className={
                  flag && flag2 && flag3 && flag4 ? "btnRaml" : "btnRaml e"
                }
                to={""}
                onClick={nextComponent}
              >
                تایید
              </Button>
            )}
            {state > 4 && <Navigate to={"/ramlpic"} />}
            {/* <Link className='login-link' to={''} >پاکن</Link> */}
          </Col>
        </Row>
      </Container>
    </>
  );
}
